<template>
    <!-- eslint-disable -->
    <div class="tree-item">
        <!-- 缩进 -->
        <div :style="{ paddingLeft: `${level * 20}px` }" class="tree-node">
            <!-- 展开/折叠按钮 -->
            <span v-if="hasChildren" class="toggle-btn" @click="toggleExpand">
                {{ expanded ? '−' : '+' }}
            </span>
            <span v-else class="toggle-btn placeholder"></span>

            <!-- 复选框 -->
            <el-checkbox class="tree-checkbox" v-model="node.checked" @change="handleCheck"  :id="`node-${node.I_门店Id}`" />
            <!-- <el-checkbox class="tree-checkbox" v-model="node.checked" @change="handleCheck" :indeterminate="node.I_是否半选" :id="`node-${node.I_门店Id}`" /> -->

            <div class="node-label" @click="handleClick">
                <div class="custom-tree-node" :class="{ 'clicked-node':  node.I_门店Id === clickedNodeId }">
                    <div style="margin-right: 10px;">
                        <span class="tag" :class="getTagClass(node.C_门店类型)" v-if="node.C_门店类型">
                            {{ node.C_门店类型 }}
                        </span>
                    </div>
                    <div style="flex: 1 1;"><span v-if="node.I_门店Id">({{ node.I_门店Id }})</span> {{ node.C_门店名称 }}</div>
                </div>
            </div>
        </div>

        <!-- 子节点 -->
        <div v-if="expanded && hasChildren" class="tree-children">
            <CustomTreeItem v-for="child in node.list.Where(a=>根据搜索判断节点是否显示(a))" :key="child.I_门店Id" :filterText="filterText" :node="child" :level="level + 1" :clickedNodeId="clickedNodeId" @check="handleChildCheck" @click="handleChildClick" />
        </div>
    </div>
</template>

<script>
import elTipsVue from './el-tips.vue'
/* eslint-disable */ // 禁用整个文件的ESLint校验
export default {
    name: 'TreeItem',
    props: {
        node: {
            type: Object,
            required: true,
            default: () => ({ check: false })
        },
        level: {
            type: Number,
            default: 0
        },
        clickedNodeId: {
            type: Number,
            default: 0
        },
        filterText: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            expanded: true // 默认展开
        }
    },
    computed: {
        hasChildren() {
            return this.node.list && this.node.list.length > 0
        }
    },
    methods: {
        // 切换展开/折叠
        toggleExpand() {
            this.expanded = !this.expanded
        },
        // 复选框变更
        async handleCheck(e) {
            //console.log('el-check节点:', this.node.C_门店名称, '勾选状态:', e);
            this.node.checked = e

            //父子联动（可选）
            // if (this.hasChildren) {
            //     await this.toggleChildCheck(this.node.list, e)
            // }
            this.$emit('check', {
                node: this.node,
                checked: e
            })
        },
        // 递归切换子节点勾选状态
        toggleChildCheck(nodes, checked) {
            nodes.forEach(node => {
                this.$set(node, 'check', checked)
                if (node.list && node.list.length) {
                    this.toggleChildCheck(node.list, checked)
                }
            })
        },
        // 节点点击
        handleClick() {
            this.$emit('click', this.node)
        },
        // 子节点勾选事件透传
        handleChildCheck(data) {
            //console.log('组件节点:', data);
            this.$emit('check', data)
        },
        // 子节点点击事件透传
        handleChildClick(node) {
            this.$emit('click', node)
        },
        // 获取标签样式类
        getTagClass(type) {
            switch (type) {
                case '门店': return 'tag-store';
                case '配送中心': return 'tag-distribution';
                case '分组': return 'tag-group';
                case '外部客户': return 'tag-customer';
                default: return 'tag-default';
            }
        },
        根据搜索判断节点是否显示(node) {
            if (this.filterText === '') {
                return true;
            }

            if (node.list && node.list.length) {
                return node.list.some(child => this.根据搜索判断节点是否显示(child));
            }

            if (node.C_门店名称.includes(this.filterText) || String(node.I_门店Id).includes(this.filterText)) {
                return true;
            }

            return false;
        }
    }
}
</script>

<style scoped>
.tree-item {
    line-height: 1.8;
}

.tree-node {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 2px 0;
}

.toggle-btn {
    display: inline-block;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    border: 1px solid #ccc;
    border-radius: 3px;
    margin-right: 4px;
    cursor: pointer;
    user-select: none;
}

.toggle-btn.placeholder {
    visibility: hidden;
}

.tree-checkbox {
    margin: 0 6px 0 0;
    cursor: pointer;
}

.node-label {
    flex: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.custom-tree-node {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
}
.clicked-node {
    background: #ccc;
}

.tag {
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 12px;
    margin-right: 8px;
}

.tag-store {
    background: #e1f5fe;
    color: #01579b;
}

.tag-distribution {
    background: #ffebee;
    color: #c62828;
}

.tag-group {
    background: #fff8e1;
    color: #ff8f00;
}

.tag-customer {
    background: #e8f5e9;
    color: #2e7d32;
}

.tag-default {
    background: #f5f5f5;
    color: #424242;
}

.tree-children {
    margin-left: 10px;
}
</style>